import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = { at: 0, list: [] };

export const useDevSections = (refreshKey = 0) => {
  const [list, setList] = useState(_cache.list);
  useEffect(() => {
    if (refreshKey === 0 && Date.now() - _cache.at < 60_000 && _cache.list.length) { setList(_cache.list); return; }
    api.get("/finance/dev-sections").then((r) => { _cache = { at: Date.now(), list: r.data || [] }; setList(_cache.list); }).catch(() => {});
  }, [refreshKey]);
  return list;
};

// Opciones para ComboInput en captura (Mi Turno / Operaciones): solo nombre, sin precio.
export const useDevSectionOptions = () =>
  useDevSections().filter((s) => s.active !== false).map((s) => ({ value: s.name, price: s.price_per_ml }));
